import * as v from 'valibot';

import {
  type Entities,
  type Filters,
  type FiltersUpdateApi,
  type Option,
  optionSchema,
  paginatedSchema,
} from './_core.model';

export const branchApiSchema = v.object({
  branchDesc: v.string(),
  customerKey: v.number(),
  divisionKey: v.pipe(
    v.nullish(v.number()),
    v.transform((value) => value ?? undefined),
  ),
  id: v.number(),
  regionKey: v.pipe(
    v.nullish(v.number()),
    v.transform((value) => value ?? undefined),
  ),
  status: v.pipe(
    v.nullish(v.string()),
    v.transform((value) => value ?? undefined),
  ),
});

export const branchSchema = v.object({
  ...branchApiSchema.entries,
  ...optionSchema.entries,
  divisionKey: v.optional(v.number()),
  regionKey: v.optional(v.number()),
  status: v.optional(v.string()),
});

export const branchesApiSchema = paginatedSchema(branchApiSchema);

export type BranchApi = v.InferOutput<typeof branchApiSchema>;
export type BranchesApi = v.InferOutput<typeof branchesApiSchema>;

export type BranchFilters = Filters<BranchApi>;

export type BranchFiltersUpdateApi = FiltersUpdateApi<BranchApi>;

export type Branch = Prettify<Option<v.InferOutput<typeof branchSchema>>>;

export type Branches = Entities<Branch>;
